import request from './request'

export function getEnterpriseInvoiceCustomerPage(data) {
  return request.post('/enterprise-invoice/customers/page', data)
}

export function createEnterpriseInvoiceCustomer(data) {
  return request.post('/enterprise-invoice/customers', data)
}

export function createEnterpriseInvoiceCustomerWithMonth(planId, data) {
  return request.post(`/enterprise-invoice/plans/${planId}/customers/create-with-master`, data)
}

export function updateEnterpriseInvoiceCustomer(id, data) {
  return request.put(`/enterprise-invoice/customers/${id}`, data)
}

export function getEnterpriseInvoiceCustomer(id) {
  return request.get(`/enterprise-invoice/customers/${id}`)
}

export function deleteEnterpriseInvoiceCustomer(id) {
  return request.delete(`/enterprise-invoice/customers/${id}`)
}

export function getEnterpriseInvoiceCustomerTagOptions() {
  return request.get('/enterprise-invoice/customer-tags')
}

export function getEnterpriseInvoiceCustomerTags(customerId) {
  return request.get(`/enterprise-invoice/customers/${customerId}/tags`)
}

export function replaceEnterpriseInvoiceCustomerTags(customerId, data) {
  return request.put(`/enterprise-invoice/customers/${customerId}/tags`, data)
}

export function getEnterpriseInvoicePlanPage(data) {
  return request.post('/enterprise-invoice/plans/page', data)
}

export function createEnterpriseInvoicePlan(data) {
  return request.post('/enterprise-invoice/plans', data)
}

export function copyEnterpriseInvoicePlan(data) {
  return request.post('/enterprise-invoice/plans/copy', data)
}

export function getEnterpriseInvoicePlan(id) {
  return request.get(`/enterprise-invoice/plans/${id}`)
}

export function getEnterpriseInvoiceCustomerWorkbench(planId, params = {}) {
  return request.get(`/enterprise-invoice/plans/${planId}/customer-workbench`, { params })
}

export function confirmEnterpriseInvoicePlan(id, data = {}) {
  return request.post(`/enterprise-invoice/plans/${id}/confirm`, data)
}

export function getEnterpriseInvoicePlanCustomers(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/customers`)
}

export function addEnterpriseInvoicePlanCustomer(planId, data) {
  return request.post(`/enterprise-invoice/plans/${planId}/customers`, data)
}

export function updateEnterpriseInvoicePlanCustomer(planId, planCustomerId, data) {
  return request.put(`/enterprise-invoice/plans/${planId}/customers/${planCustomerId}`, data)
}

export function deleteEnterpriseInvoicePlanCustomer(planId, planCustomerId) {
  return request.delete(`/enterprise-invoice/plans/${planId}/customers/${planCustomerId}`)
}

export function getEnterpriseInvoiceDownstreamAllocations(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/downstream-allocations`)
}

export function replaceEnterpriseInvoiceDownstreamAllocations(planId, planCustomerId, data) {
  return request.put(`/enterprise-invoice/plans/${planId}/customers/${planCustomerId}/downstream-allocations`, data)
}

export function getEnterpriseInvoiceDownstreamTagPreferences(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/downstream-tag-preferences`)
}

export function replaceEnterpriseInvoiceDownstreamTagPreferences(planId, planCustomerId, data) {
  return request.put(`/enterprise-invoice/plans/${planId}/customers/${planCustomerId}/downstream-tag-preferences`, data)
}

export function getEnterpriseInvoiceRegions(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/regions`)
}

export function createEnterpriseInvoiceRegion(planId, data) {
  return request.post(`/enterprise-invoice/plans/${planId}/regions`, data)
}

export function updateEnterpriseInvoiceRegion(planId, regionId, data) {
  return request.put(`/enterprise-invoice/plans/${planId}/regions/${regionId}`, data)
}

export function deleteEnterpriseInvoiceRegion(planId, regionId) {
  return request.delete(`/enterprise-invoice/plans/${planId}/regions/${regionId}`)
}

export function sortEnterpriseInvoiceRegionsByAmount(planId, descending = true) {
  return request.post(`/enterprise-invoice/plans/${planId}/regions/sort-by-amount?descending=${descending}`, {})
}

export function reorderEnterpriseInvoiceRegions(planId, data) {
  return request.post(`/enterprise-invoice/plans/${planId}/regions/reorder`, data)
}

export function moveEnterpriseInvoiceCustomers(planId, regionId, data) {
  const payload = { ...data, targetRegionId: data?.targetRegionId ?? regionId }
  return request.post(`/enterprise-invoice/plans/${planId}/regions/${regionId}/customers/move`, payload)
}

export function confirmEnterpriseInvoiceList(planId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/regions/confirm-list`, data)
}

export function generateEnterpriseInvoiceChains(planId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/generate`, data)
}

export function regenerateEnterpriseInvoiceUnlockedChains(planId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/regenerate-unlocked`, data)
}

export function regenerateEnterpriseInvoiceChain(planId, chainId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/regenerate`, data)
}

export function regenerateEnterpriseInvoiceAfterNode(planId, chainId, nodeId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/regenerate-after-node/${nodeId}`, data)
}

export function generateEnterpriseInvoiceForUnfilledCustomers(planId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/generate-for-unfilled-customers`, data)
}

export function getEnterpriseInvoiceChains(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/chains`)
}

export function exportEnterpriseInvoiceChains(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/chains/export`, {
    responseType: 'blob'
  })
}

export function getEnterpriseInvoiceCompanyChainRelations(planId, companyName) {
  return request.get(`/enterprise-invoice/plans/${planId}/chains/company-relations`, {
    params: { companyName }
  })
}

export function getEnterpriseInvoiceChain(planId, chainId) {
  return request.get(`/enterprise-invoice/plans/${planId}/chains/${chainId}`)
}

export function updateEnterpriseInvoiceChainNode(planId, chainId, nodeId, data) {
  return request.put(`/enterprise-invoice/plans/${planId}/chains/${chainId}/nodes/${nodeId}`, data)
}

export function lockEnterpriseInvoiceChain(planId, chainId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/lock`, data)
}

export function unlockEnterpriseInvoiceChain(planId, chainId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/unlock`, data)
}

export function lockEnterpriseInvoiceChainNode(planId, chainId, nodeId, data) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/nodes/${nodeId}/lock`, data)
}

export function unlockEnterpriseInvoiceChainNode(planId, chainId, nodeId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/chains/${chainId}/nodes/${nodeId}/unlock`, data)
}

export function validateEnterpriseInvoicePlan(planId, data = {}) {
  return request.post(`/enterprise-invoice/plans/${planId}/validate`, data)
}

export function getEnterpriseInvoiceValidationIssues(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/validation-issues`)
}

export function getEnterpriseInvoiceCapacityLedger(planId) {
  return request.get(`/enterprise-invoice/plans/${planId}/capacity-ledger`)
}
